$( window ).on( "load", function() {
  const swiper = new Swiper('.swiper', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 2,
    spaceBetween: 0,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 2000,
    },
    breakpoints: {
      768: {
        slidesPerView: 5,
      }
    }
  });
  $("#announcement-bar p button").click(function() { 
    var currentAnnouncement = $(this).attr("data-announcement-id");
    $("#"+currentAnnouncement).show();
    $("html").addClass("popup-triggered");
    $(".announcement-close-button").click(function() { 
      $(".single-announcement-wrapper").hide();
      $("html").removeClass("popup-triggered");
    });
    $(".tap-area").click(function() { 
      $(".single-announcement-wrapper").hide();
      $("html").removeClass("popup-triggered");
    });
  });
  $("section#shopify-section-template--17014551019716__impact_text_w4ijyw button.button.button--xl").click(function() {
    $(".google-reviews-popup-wrapper").show();
    $("html").addClass("popup-triggered");
    $(".google-reviews-close-popup").click(function() {
      $(".google-reviews-popup-wrapper").hide();
      $("html").removeClass("popup-triggered");
    });
  });
  $(".google-reviews-popup-wrapper").click(function(e) { 
    if ($(event.target).is($(".google-reviews-popup-wrapper"))){   
      $(".google-reviews-popup-wrapper").hide();  
      $("html").removeClass("popup-triggered");
    }     
  });
(function(){var vv=window.visualViewport;if(!vv)return;var lockY=null;function fit(){var d=document.getElementById('metapod-chat-drawer');if(!d)return;if(d.classList.contains('open')){if(lockY===null){lockY=window.pageYOffset||0;var b=document.body.style;b.setProperty('position','fixed','important');b.setProperty('top',-lockY+'px','important');b.setProperty('left','0','important');b.setProperty('width','100%','important');}d.style.setProperty('height','100lvh','important');d.style.setProperty('box-sizing','border-box','important');d.style.setProperty('padding-bottom',Math.max(0,d.offsetHeight-vv.height-vv.offsetTop)+'px','important');if(vv.offsetTop>0||window.pageYOffset>0)window.scrollTo(0,0);}else{d.style.removeProperty('height');d.style.removeProperty('top');d.style.removeProperty('box-sizing');d.style.removeProperty('padding-bottom');if(lockY!==null){var c=document.body.style;c.removeProperty('position');c.removeProperty('top');c.removeProperty('left');c.removeProperty('width');window.scrollTo(0,lockY);lockY=null;}}}function init(){var d=document.getElementById('metapod-chat-drawer');if(!d){setTimeout(init,500);return;}new MutationObserver(fit).observe(d,{attributes:true,attributeFilter:['class']});vv.addEventListener('resize',fit);vv.addEventListener('scroll',fit);}init();})();  var descHeight = $(".product-description-container").height();
  var specHeight = $(".product-tech-specs-container").height();
  var newHeight = (descHeight-25.59);
  if ( descHeight > specHeight ) {
    $(".specifications-wrapper").height(newHeight);
  }
  else {
    $(".specifications-wrapper").height('704px');      
  }
  $(".single-icon").click(function() {
    var currentIcon = $(this).attr("data-icon-name");
    $("#"+currentIcon).show();
    $("html").addClass("popup-triggered");
    $(".trust-widget-close-popup").click(function() {
      $(".trust-widget-popup-wrapper").hide();
      $("html").removeClass("popup-triggered");
    });
  });
  $(".trust-widget-popup-wrapper").click(function(e) { 
    if ($(event.target).is($(".trust-widget-popup-wrapper"))){   
      $(".trust-widget-popup-wrapper").hide();  
      $("html").removeClass("popup-triggered");
    }     
  });
  $(".single-announcement-wrapper").click(function(e) { 
    if ($(event.target).is($(".single-announcement-wrapper"))){   
      $(".single-announcement-wrapper").hide();  
      $("html").removeClass("popup-triggered");
    }     
  });
  var descHeight = $(".product-info__description").height();
  if (descHeight > 500) {
    $(".product-info__description").addClass("collapse-content");
    $(".continue-reading").addClass("is-active");
  }
  $(".continue-reading.is-active").click(function(e) { 
    $(".product-info__description").removeClass("collapse-content");
    $(this).removeClass("is-active");
    $(".collapse-reading").addClass("is-active"); 
    $(".collapse-reading.is-active").click(function(e) { 
      $(".product-info__description").addClass("collapse-content");
      $(this).removeClass("is-active");
      $(".continue-reading").addClass("is-active"); 
    });
  });
  jQuery('.slideshow__slides-container').slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000
  });
  $(".block-swatch, .color-swatch").click(function(){
    setTimeout(function() {
var currentPrice = parseInt($('sale-price.text-lg').text().replace(/[^0-9.]/g, ""));
      var grabPrice = currentPrice/4;
      $(".product .grab-price").html("S$"+grabPrice);
      var atomePrice = (currentPrice/3).toFixed(2);
      $(".product .atome-price").html("S$"+atomePrice);
    }, 2);
  });
});